const { is } = require("bpmnlint-utils");

/**
 * Rule that checks whether a Boundary Event has at least one outgoing arrow.
 *
 * The linter walks the semantic model (`getDefinitions()`), which can still hold a
 * `bpmn:BoundaryEvent` businessObject that has NO rendered shape — an orphan left in the stored XML
 * (e.g. a boundary event whose shape was removed but whose businessObject wasn't reconciled). Such an
 * orphan is invisible on the canvas, so bpmn-js-bpmnlint re-homes the report to the diagram root and
 * it surfaces as a phantom "boundary event needs an arrow" error the user can neither see nor fix.
 * Only lint boundary events that are actually rendered (present in the elementRegistry); a genuine,
 * on-canvas boundary event without an arrow is still reported.
 */

module.exports = function boundaryEventHasOutgoing({ ctx } = {}) {
  return {
    check(node, reporter) {
      if (!is(node, "bpmn:BoundaryEvent")) {
        return;
      }

      // Skip orphans not on the canvas. Fall back to reporting when no registry is available
      // (e.g. a headless lint run), preserving the original behaviour there.
      const registry = ctx && ctx.elementRegistry;
      if (registry && typeof registry.get === "function" && !registry.get(node.id)) {
        return;
      }

      const outgoing = Array.isArray(node.outgoing) ? node.outgoing : [];

      if (outgoing.length === 0) {
        reporter.report(node.id, "The 'Boundary Event' node needs at least one arrow.");
      }
    }
  };
};
